(() => {
  const SELECTOR = "[data-highlight-text]";
  const PRELOAD_MARGIN = "350px 0px";

  function libsReady() {
    return window.gsap && window.ScrollTrigger && window.SplitText;
  }

  function fallback(el) {
    el.style.opacity = "1";
    el.style.visibility = "visible";
  }

  function initHighlightText(el) {
    if (el.dataset.highlightInited === "1") return;
    el.dataset.highlightInited = "1";

    if (!libsReady()) {
      fallback(el);
      return;
    }

    gsap.registerPlugin(ScrollTrigger, SplitText);

    const scrollStart =
      el.getAttribute("data-highlight-scroll-start") || "top 90%";

    const scrollEnd =
      el.getAttribute("data-highlight-scroll-end") || "center 40%";

    const fadedValue =
      parseFloat(el.getAttribute("data-highlight-fade")) || 0.2;

    const staggerValue =
      parseFloat(el.getAttribute("data-highlight-stagger")) || 0.1;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      fallback(el);
      return;
    }

    try {
      const split = new SplitText(el, {
        type: "words, chars",
        wordsClass: "split-word",
        charsClass: "split-char"
      });

      gsap.set(split.chars, {
        autoAlpha: fadedValue,
        willChange: "opacity"
      });

      gsap.to(split.chars, {
        autoAlpha: 1,
        ease: "none",
        stagger: staggerValue,
        scrollTrigger: {
          trigger: el,
          start: scrollStart,
          end: scrollEnd,
          scrub: 0.35,
          invalidateOnRefresh: false
        },
        onComplete: () => {
          gsap.set(split.chars, { clearProps: "willChange" });
        }
      });
    } catch (e) {
      fallback(el);
    }
  }

  function boot() {
    const targets = Array.from(document.querySelectorAll(SELECTOR));

    if (!targets.length) return;

    targets.forEach(fallback);

    if (!("IntersectionObserver" in window)) {
      targets.forEach(initHighlightText);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          initHighlightText(entry.target);
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: PRELOAD_MARGIN,
        threshold: 0
      }
    );

    targets.forEach((el) => observer.observe(el));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();